import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.timers";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { enumData } from '@/decorators';
import pdfJs from '@/utils/pdfPreview';
import Throttling from '@/utils/throttling';
import { StartupStatus } from '@/enum';

var SignUpContract = function (_super) {
  __extends(SignUpContract, _super);

  function SignUpContract() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.contractTypeEnum = [];
    _this.isButtonDisabled = true;
    _this.countNum = 3;
    _this.timer = null;
    _this.goOnSignVisible = false;
    _this.returnSignListVisible = false;
    _this.completeSignVisible = false;
    _this.height = 0;
    _this.pageLoadCount = 0;
    _this.nextContractType = null;
    _this.authVisible = false;
    _this.authUrl = '';
    _this.authTimer = null;
    _this.sealLoading = false;
    _this.formData = {
      sms_code: '',
      account_code: '',
      contract_id: ''
    };
    _this.cacheData = {
      contrace_file_base64: '',
      contract_state: _this.$enum.mine.ContractStateEnum.CREATE_PENDING,
      contract_type: _this.$enum.mine.ContractTypeEnum.OVERSEA_LOCATION,
      sign_body_contract_id: 0
    };
    _this.data = {
      contrace_file_base64: '',
      contract_state: _this.$enum.mine.ContractStateEnum.CREATE_PENDING,
      contract_type: _this.$enum.mine.ContractTypeEnum.OVERSEA_LOCATION,
      sign_body_contract_id: 0
    };
    return _this;
  }

  SignUpContract_1 = SignUpContract;
  Object.defineProperty(SignUpContract.prototype, "contractText", {
    get: function get() {
      if (this.contractTypeEnum) {
        return this.$util.getEnumTextByValue(this.contractTypeEnum, this.data.contract_type);
      } else {
        return '';
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(SignUpContract.prototype, "nextContractText", {
    get: function get() {
      if (this.contractTypeEnum && this.nextContractType !== null) {
        return this.$util.getEnumTextByValue(this.contractTypeEnum, this.nextContractType);
      } else {
        return '';
      }
    },
    enumerable: false,
    configurable: true
  });

  SignUpContract.prototype.queryStartupInfo = function () {
    return __awaiter(this, void 0, Promise, function () {
      var res, e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            return [4, this.$api.certification.queryStartupInfo()];

          case 1:
            res = _a.sent();
            return [2, res.data];

          case 2:
            e_1 = _a.sent();
            return [2, null];

          case 3:
            return [2];
        }
      });
    });
  };

  SignUpContract.prototype.sendContractSignIdentityAuth = function () {
    return __awaiter(this, void 0, Promise, function () {
      var res, e_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            return [4, this.$api.contract.sendContractSignIdentityAuth({
              id: this.formData.contract_id
            })];

          case 1:
            res = _a.sent();
            return [2, res.code === 0 ? res.data : null];

          case 2:
            e_2 = _a.sent();
            return [2, null];

          case 3:
            return [2];
        }
      });
    });
  };

  SignUpContract.prototype.queryAuthState = function () {
    return __awaiter(this, void 0, Promise, function () {
      var res, e_3;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            return [4, this.$api.contract.getContractSignIdentityAuthState({
              id: this.formData.contract_id
            }, {
              hideAllError: true
            })];

          case 1:
            res = _a.sent();
            return [2, res.code === 0 ? res.data : null];

          case 2:
            e_3 = _a.sent();
            return [2, null];

          case 3:
            return [2];
        }
      });
    });
  };

  SignUpContract.prototype.startAuthStatePolling = function () {
    var _this = this;

    this.stopAuthStatePolling();
    this.authTimer = setInterval(function () {
      return __awaiter(_this, void 0, void 0, function () {
        var state;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4, this.queryAuthState()];

            case 1:
              state = _a.sent();

              if (state && state.auth_success) {
                this.stopAuthStatePolling();
                this.authVisible = false;
                this.$message.success(this.tc('认证成功'));
              }

              return [2];
          }
        });
      });
    }, SignUpContract_1.AUTH_STATE_POLL_INTERVAL);
  };

  SignUpContract.prototype.stopAuthStatePolling = function () {
    if (this.authTimer !== null) {
      clearInterval(this.authTimer);
      this.authTimer = null;
    }
  };

  SignUpContract.prototype.handleCancelAuth = function () {
    this.stopAuthStatePolling();
    this.authVisible = false;
  };

  SignUpContract.prototype.handleGoAuth = function () {
    if (this.authUrl) {
      window.open(this.authUrl, '_blank');
    }
  };

  SignUpContract.prototype.queryContractFile = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.contract.queryContractFile(params)];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              this.data = res.data;
              this.previewPdf(res.data.contrace_file_base64);
            }

            return [2];
        }
      });
    });
  };

  SignUpContract.prototype.sealContract = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.contract.seal(params)];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              return [2, res.data];
            }

            return [2];
        }
      });
    });
  };

  SignUpContract.prototype.previewPdf = function (base64) {
    var _this = this;

    var pageLoadCount = 0;
    var height = 0;
    var pageArr = this.$util.range(1, 10);
    this.$nextTick(function () {
      pdfJs.preview(_this.$refs.canvasBox, base64, true, function (viewRepost, pageNumber) {
        pageLoadCount++;

        if (pageArr.indexOf(pageNumber) > -1) {
          height += viewRepost.height;
          _this.height = height;
        }

        _this.pageLoadCount = pageLoadCount;
      });
    });
  };

  SignUpContract.prototype.startTimer = function () {
    var _this = this;

    if (this.timer !== null) {
      this.countNum = 3;
      clearInterval(this.timer);
    }

    this.timer = setInterval(function () {
      if (_this.countNum <= 0) {
        if (_this.timer !== null) {
          clearInterval(_this.timer);
        }

        _this.countNum = 3;
        window.location.href = _this.$config.homeUrl;
        return;
      }

      _this.countNum--;
    }, 1000);
  };

  SignUpContract.prototype.getUnsignedContract = function (signBusinessTypeList) {
    var _this = this;

    var res = signBusinessTypeList instanceof Array ? signBusinessTypeList.filter(function (val) {
      return Number(val) !== Number(_this.data.contract_type);
    }) : [];

    if (res.length) {
      return res[0];
    } else {
      return null;
    }
  };

  SignUpContract.prototype.handleGoOnSignUp = function () {
    this.data = this.cacheData;
    this.isButtonDisabled = true;
    document.querySelector('#layout-main').scrollTop = 0;
    this.formData.contract_id = this.cacheData.sign_body_contract_id.toString();
    this.previewPdf(this.data.contrace_file_base64);
    this.goOnSignVisible = false;
  };

  SignUpContract.prototype.handleOk = function () {
    window.location.href = this.$config.homeUrl;
    this.completeSignVisible = false;
  };

  SignUpContract.prototype.handleConfirmReturnSignList = function () {
    this.$router.push({
      name: 'CertificationPage',
      query: {
        status: StartupStatus.sign_contract
      }
    });
  };

  SignUpContract.prototype.handleSeal = function () {
    return __awaiter(this, void 0, Promise, function () {
      var authResult, authLink;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (this.sealLoading || this.authVisible) {
              return [2];
            }

            this.sealLoading = true;
            _a.label = 1;

          case 1:
            _a.trys.push([1,, 5, 6]);

            return [4, this.sendContractSignIdentityAuth()];

          case 2:
            authResult = _a.sent();
            if (!(authResult && authResult.AuthSuccess)) return [3, 4];
            return [4, this.doSeal()];

          case 3:
            _a.sent();

            return [2];

          case 4:
            authLink = authResult ? authResult.ShortLink || authResult.Url : '';

            if (!authLink) {
              this.$message.warn(this.tc('获取认证链接失败，请稍后重试'));
              return [2];
            }

            this.authUrl = authLink;
            this.authVisible = true;
            this.startAuthStatePolling();
            return [3, 6];

          case 5:
            this.sealLoading = false;
            return [7];

          case 6:
            return [2];
        }
      });
    });
  };

  SignUpContract.prototype.doSeal = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data, startupInfo, signBodyInfo;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.sealContract(this.formData)];

          case 1:
            data = _a.sent();
            if (!data) return [3, 2];
            this.cacheData = data;
            this.nextContractType = this.cacheData.contract_type;
            this.goOnSignVisible = true;
            return [3, 4];

          case 2:
            if (!(data === null)) return [3, 4];
            return [4, this.queryStartupInfo()];

          case 3:
            startupInfo = _a.sent();

            if (startupInfo) {
              if (startupInfo.status === StartupStatus.sign_contract) {
                signBodyInfo = startupInfo.sign_body_info;
                this.nextContractType = signBodyInfo ? this.getUnsignedContract(signBodyInfo.sign_business_type_list || []) : null;
                this.returnSignListVisible = true;
              } else if (this.$store.state && this.$store.state.user.bodyStatus === StartupStatus.active) {
                this.queryContractFile({
                  id: this.formData.contract_id
                });
                this.$message.success(this.tc('盖章成功'));
              } else {
                this.completeSignVisible = true;
                this.startTimer();
              }
            } else {
              this.$message.warn(this.tc('接口异常'));
            }

            _a.label = 4;

          case 4:
            return [2];
        }
      });
    });
  };

  SignUpContract.prototype.created = function () {
    this.formData.account_code = this.$route.query.account_code, this.formData.contract_id = this.$route.query.contract_id, this.queryContractFile({
      id: this.formData.contract_id
    });
  };

  SignUpContract.prototype.mounted = function () {
    return __awaiter(this, void 0, void 0, function () {
      var throttling;

      var _this = this;

      return __generator(this, function (_a) {
        throttling = new Throttling();

        this.handleScroll = function () {
          throttling.handle(function () {
            if (document.querySelector('#canvasBox')) {
              var scrollTop = document.querySelector('#layout-main').scrollTop;

              if (scrollTop > _this.height && _this.pageLoadCount >= 10) {
                _this.isButtonDisabled = false;
              }
            }
          });
        };

        window.addEventListener('scroll', this.handleScroll, true);
        return [2];
      });
    });
  };

  SignUpContract.prototype.destroyed = function () {
    this.handleScroll && window.removeEventListener('scroll', this.handleScroll);
    this.stopAuthStatePolling();
  };

  var SignUpContract_1;
  SignUpContract.AUTH_STATE_POLL_INTERVAL = 3000;

  __decorate([enumData('Customer/ContractTypeEnum')], SignUpContract.prototype, "contractTypeEnum", void 0);

  SignUpContract = SignUpContract_1 = __decorate([Component({})], SignUpContract);
  return SignUpContract;
}(Vue);

export default SignUpContract;